import React, { useEffect, useState } from "react";
import NewModal from "../../Utils/Visuales/NewModal";
import { Grid } from "@mui/material";
import styles from "./styles.module.css";
import { useSnackbar } from "notistack";
import moment from "moment";
import { postRequest } from "../../Utils/Funciones/requester";
import Select from "react-select";

const CreateConceptosDePagoParaGruposCerrados = ({
  open,
  close,
  userName,
  id,
  allInfo,
  getDataTable,
  options,
  campusId,
  campusUser2,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [newData, setNewData] = useState({});
  const validCampusArray = campusUser2?.map((campus) => campus?.value);
  const campusOptions = options?.campus?.filter((campus) =>
    validCampusArray?.includes(campus?.value)
  );

  useEffect(() => {
    const initialCampus = options?.campus?.find(
      (campus) => `${campus?.value}` === `${campusId}`
    );
    setNewData((prev) => ({ ...prev, campus: "" }));
  }, [options, campusId]);

  const handleSubmit = async () => {
    if (newData?.campus === undefined) {
      enqueueSnackbar("Se debe ingresar un campus", {
        variant: "error",
        autoHideDuration: null,
        anchorOrigin: {
          vertical: "top",
          horizontal: "left",
        },
      });
    } else if (newData?.escuela === undefined) {
      enqueueSnackbar("Se debe ingresar una escuela", {
        variant: "error",
        autoHideDuration: null,
        anchorOrigin: {
          vertical: "top",
          horizontal: "left",
        },
      });
    } else if (newData?.concepto === undefined) {
      enqueueSnackbar("Se debe ingresar un concepto", {
        variant: "error",
        autoHideDuration: null,
        anchorOrigin: {
          vertical: "top",
          horizontal: "left",
        },
      });
    } else {
      try {
        setLoading(true);
        const payload = {
          id,
          data: [
            ...allInfo?.filter((data) => data?.campus),
            {
              modificado: moment().format("YYYY-MM-DD hh:mm:ss"),
              modificado_por: userName,
              campus: `${newData?.campus?.clave}-${newData?.campus?.nombre}`,
              escuela: `${newData?.escuela?.value}-${newData?.escuela?.nombre}`,
              concepto: `${newData?.concepto?.clave}-${newData?.concepto?.nombre}`,
              estatus: "activo",
              creado: moment().format("YYYY-MM-DD hh:mm:ss"),
              creado_por: userName,
            },
          ],
        };
        const response = await postRequest("/parametro_reglas", payload);
        if (response.s === "OK") {
          enqueueSnackbar(response.m, {
            variant: "success",
            anchorOrigin: {
              vertical: "top",
              horizontal: "left",
            },
          });
          getDataTable(id);
          handleClose();
        } else {
          enqueueSnackbar(response.m, {
            variant: "error",
            autoHideDuration: null,
            anchorOrigin: {
              vertical: "top",
              horizontal: "left",
            },
          });
        }
      } finally {
        setLoading(false);
      }
    }
  };

  const handleChangeCampus = (event) => {
    setNewData((prev) => ({ ...prev, campus: event }));
  };

  const handleChangeEscuela = (event) => {
    setNewData((prev) => ({ ...prev, escuela: event }));
  };

  const handleChangeConcepto = (event) => {
    setNewData((prev) => ({ ...prev, concepto: event }));
  };

  const handleClose = () => {
    setNewData({});
    close((prev) => ({
      ...prev,
      param70: false,
    }));
  };

  return (
    <NewModal
      title={`Configuración Pagos Extraordinarios a Grupos Cerrados`}
      open={open}
      handleClose={handleClose}
      maxWidth={900}
      height={200}
      loading={loading}
      overflowY={"unset"}
      handleSubmit={handleSubmit}
    >
      <div style={{ padding: "25px" }}>
        <Grid
          container
          spacing={1}
          style={{
            marginBottom: "30px",
            alignItems: "center",
            justifyContent: "space-evenly",
          }}
        >
          <Grid item xs={3}>
            <label className={styles.inputLabel}>Campus:</label>
          </Grid>
          <Grid item xs={8}>
            <Select
              classNamePrefix="select-modal"
              options={campusOptions}
              styles={{
                container: (styles) => ({ ...styles, zIndex: 19 }),
                singleValue: (styles) => ({ ...styles, textAlign: "center" }),
              }}
              onChange={handleChangeCampus}
              value={newData?.campus}
            />
          </Grid>
          <Grid item xs={3}>
            <label className={styles.inputLabel}>Escuela:</label>
          </Grid>
          <Grid item xs={8}>
            <Select
              classNamePrefix="select-modal"
              options={options?.escuelas}
              styles={{
                container: (styles) => ({ ...styles, zIndex: 18 }),
                singleValue: (styles) => ({ ...styles, textAlign: "center" }),
              }}
              onChange={handleChangeEscuela}
              value={newData?.escuela}
            />
          </Grid>
          <Grid item xs={3}>
            <label className={styles.inputLabel}>Concepto:</label>
          </Grid>
          <Grid item xs={8}>
            <Select
              classNamePrefix="select-modal"
              options={options?.conceptos}
              styles={{
                container: (styles) => ({ ...styles, zIndex: 17 }),
                singleValue: (styles) => ({ ...styles, textAlign: "center" }),
              }}
              onChange={handleChangeConcepto}
              value={newData?.concepto}
            />
          </Grid>
          <Grid item xs={3}>
            <label className={styles.inputLabel}>Estatus:</label>
          </Grid>
          <Grid item xs={8}>
            <input className={styles.filterInput} value={"activo"} disabled />
          </Grid>
        </Grid>
      </div>
    </NewModal>
  );
};

export default CreateConceptosDePagoParaGruposCerrados;
